import { Box, FormGroup, Select, Text } from '@ksyos/design-system';
import type { FollowupData, OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { TreatmentOptionsKeys } from './utils';
import { weeksOptions } from '../weeksOptions';
import { treatmentOptions } from './utils';

type TreatmentFollowUpsProps = {
    data: OsasTreatmentData;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
    treatmentName: TreatmentOptionsKeys;
};
export function TreatmentFollowUps(props: Readonly<TreatmentFollowUpsProps>) {
    const { data, onChange, treatmentName } = props;
    if (treatmentName === 'lifestyle' || treatmentName === 'refer' || treatmentName === 'other') {
        return null;
    }

    const treatmentInfo = treatmentOptions[treatmentName].find(
        (treatment) => treatment.label === data.treatment[treatmentName]
    );

    if (!treatmentInfo) {
        return null;
    }

    const followUps: FollowupData[] = data.treatmentFollowUp[treatmentName] ?? treatmentInfo?.followUp ?? [];

    return (
        <>
            {followUps.map((followUp) => {
                const followupSettings = treatmentInfo?.followUp.find((fu) => fu.performer === followUp.performer);

                if (followupSettings?.hide) {
                    return null;
                }

                return (
                    <FormGroup
                        key={`${treatmentInfo.label}-${followUp.performer}`}
                        label={`Vervolgafspraak bij ${followUp.performer} na`}
                    >
                        <Box
                            alignContent={'center'}
                            alignItems={'center'}
                            display={'flex'}
                            flexDirection={'row'}
                            gap={2}
                        >
                            <Box width={'80px'}>
                                <Select
                                    onChange={async (option) => {
                                        onChange(
                                            {
                                                treatmentFollowUp: {
                                                    ...data.treatmentFollowUp,
                                                    [treatmentName]: followUps.map((fu) => {
                                                        if (fu.performer === followUp.performer) {
                                                            return {
                                                                ...fu,
                                                                weeks: parseInt(option?.value ?? '') ?? null,
                                                            };
                                                        }

                                                        return fu;
                                                    }),
                                                },
                                            },
                                            'treatmentFollowUp'
                                        );
                                    }}
                                    options={weeksOptions}
                                    value={{
                                        label: followUp.weeks.toString(),
                                        value: followUp.weeks.toString(),
                                    }}
                                />
                            </Box>
                            <Text
                                as="span"
                                color="subtle"
                                size="sm"
                            >
                                weken
                            </Text>
                        </Box>
                    </FormGroup>
                );
            })}
        </>
    );
}
